import ArrowIcon from "theme/components/icons/ArrowIcon";
import Link from "core-web/components/Link";
import PropTypes from "prop-types";
import React from "react";
import ThemeButton from "../ThemeButton";

const NavigationButton = ({ arrowSize, size, direction, to, active, theme, ...rest }) => {
    return (
        <ThemeButton as={to ? Link : "button"} to={to} size={size} buttonTheme={theme} active={active} {...rest}>
            <ArrowIcon direction={direction} width={arrowSize} height={arrowSize} />
        </ThemeButton>
    );
};

const responsivePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]);

NavigationButton.propTypes = {
    active: PropTypes.bool,
    arrowSize: responsivePropType,
    direction: PropTypes.string,
    size: responsivePropType,
    theme: PropTypes.string,
    to: PropTypes.string,
};

NavigationButton.defaultProps = {
    active: false,
    arrowSize: "14px",
    theme: "black_outlined",
    direction: "left",
    size: "xs",
    to: null,
};

export default NavigationButton;
